import { FDDialog } from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import {
  AddOrEditHouseholdMemberLayout,
} from 'Views/Page/Content/Templates/ProfilePage/ManageHouseholdMember/AddOrEditHouseholdMemberLayout';
import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import SecondaryPersonIdentityVerification
  from 'Components/ComponentLibrary/Organisms/ClientDetailForm/SecondaryPersonIdentityVerification/SecondaryPersonIdentityVerification';


const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride(['isIdentityVerified'], {
    _component: () => SecondaryPersonIdentityVerification,
  }, overrideReadOnly);

export const MobileManageHouseholdMember = ({
  resource,
  onDeleteMember,
}) => {
  const { loadPageContentLink } = usePageContentContext();
  const { displayErrorMessage } = useSnackbarContext();

  if (!resource) {
    return null;
  }

  const onCloseModal = async () => {
    try {
      await resource.withRelationship(fr.relationships.profilePageUnselected.name,
        (rel) => loadPageContentLink(rel.link('related')), () => null);
    } catch (err) {
      displayErrorMessage('An error occurred while attempting to close the modal');
    }
  };

  // Because the onCloseModal function will handle refreshing the page back to the un-selected Profile Page
  // we don't need to also refresh the page collection this time
  const onSubmitSuccess = async () => {
    await onCloseModal();
  };

  return (
    <FDDialog open={!!resource} fullScreen onClose={onCloseModal}>
      <MetaResourceRenderer
        layout={AddOrEditHouseholdMemberLayout}
        LayoutProps={{
          onCloseModal,
          onProfileImageUpload: onSubmitSuccess,
        }}
        onSubmit={onSubmitSuccess}
        resource={resource}
        onDelete={onDeleteMember}
        metaOverrideSet={metaOverrideSet}
      />
    </FDDialog>);
};

MobileManageHouseholdMember.defaultProps = {
  resource: null,
};

MobileManageHouseholdMember.propTypes = {
  resource: PropTypes.object,
  onDeleteMember: PropTypes.func.isRequired,
};
